import {UIMHomepageController} from './homepage/UIMHomepageController'
import {UIMLeaderboardController} from './leaderboard/UIMLeaderboardController'
import {UIMLobbyController} from './lobby/UIMLobbyController'
import {UIMProfileController} from './profile/UIMProfileController'
import {UIMStoreController} from './store/UIMStoreController'
import {UIMStoreBodyController} from './store/UIMStoreBodyController'
import {UIMSceneController} from '../../UIMSceneController'
import {UIMNavigationController} from '../navigation/UIMNavigationController'
import {UIMMainPageController} from '../UIMMainPageController'
import {ClientUserState} from '../../../../../shared/scripts/ClientUserState'
import Splide from '@splidejs/splide'
import {UIProfileRankedController} from '../../../../../shared/scripts/profile/UIProfileRankedController'
import {UIUtilsEjsVariables} from '../../../../../shared/scripts/UIUtilsEjsVariables'
import {UIMSceneEnum} from '../../../../../../shared/enums/UIMSceneEnums'
import {UIModeSelectorController} from '../../../../../shared/scripts/ui_html/home_page/UIModeSelectorController'
import {UIMModeSelectorDetailsController} from './homepage/UIMModeSelectorDetailsController'

export class UIMBodyController {
    private readonly bodyContainer: HTMLDivElement

    readonly homepageController: UIMHomepageController
    readonly modeSelectorController: UIModeSelectorController
    readonly modeSelectorDetailsController: UIMModeSelectorDetailsController
    readonly leaderboardController: UIMLeaderboardController
    readonly lobbyController: UIMLobbyController
    readonly storeController: UIMStoreController

    private profileController: UIMProfileController

    readonly swipeNavigation: Splide
    readonly sceneController: UIMSceneController
    readonly navigationController: UIMNavigationController

    constructor(sceneController: UIMSceneController, mainpageController: UIMMainPageController) {
        this.bodyContainer = document.getElementById('main-page-body-container') as HTMLDivElement

        const initTimestamp = Date.now()
        this.homepageController = new UIMHomepageController()

        this.modeSelectorDetailsController = new UIMModeSelectorDetailsController((matchType) => {
            void this.homepageController.matchmakingController.startGame(matchType)
        })

        this.modeSelectorController = new UIModeSelectorController(initTimestamp, (matchType) => {
            void this.homepageController.matchmakingController.startGame(matchType)
        }, (matchType) => {
            this.modeSelectorDetailsController.show(matchType)
        })

        this.leaderboardController = new UIMLeaderboardController()
        this.lobbyController = new UIMLobbyController()
        this.storeController = new UIMStoreController()
        this.sceneController = sceneController

        this.navigationController = mainpageController.navigationController
        this.swipeNavigation = new Splide('.splide', {
            type: 'slide',
            perPage: 1,
            start: 2,
            arrows: false,
            pagination: false,
            flickMaxPages: 1,
            flickPower: 100,
            perMove: 1,
            noDrag: 'input, textarea, .m-no-drag',
        }).mount()

        const track = document.getElementById('splide01-track')
        if(track) {
            track.addEventListener('touchstart', (e: TouchEvent) => {
                if(e.touches.length > 1) this.swipeNavigation.refresh()
            })
        }

        this.swipeNavigation.on('move', (e: number) => {
            this.slideChange(e)
        })

        ClientUserState.registerChangeListener(() => {
            this.init()
        })
    }

    init() {
        if(this.profileController !== undefined) return
        if(ClientUserState.userState == undefined) return
        const username = ClientUserState.userState.username
        this.profileController = new UIMProfileController(username)
        new UIProfileRankedController(username)
    }

    private slideChange(scene: number) {
        const isStoreHidden = UIUtilsEjsVariables.shouldHideStoreOnMobile
        const mappedScene = isStoreHidden && scene >= UIMSceneEnum.Store ? scene + 1 : scene
        this.sceneController.onSceneChange(mappedScene)
        this.navigationController.moveSliderTo(mappedScene)
    }

    hide() {
        this.bodyContainer.style.display = 'none'
        this.homepageController.onHomepageHide()
    }

    show() {
        this.bodyContainer.style.display = 'block'
    }

    onHomepageShow() {
        this.modeSelectorController.onHomepageShow()
    }

    onStoreShow() {
        if(!(this.storeController.bodyController instanceof UIMStoreBodyController)) return
        this.storeController.bodyController.onStoreViewVisible()
    }
}
